<template>
    <div class="text-align">
        <img src="../assets/no-data.svg" alt="">
    </div>
</template>
<script>
export default {
    data() {
        return {}
    }
}
</script>
<style lang="less" scoped>
.text-align{
    text-align: center;
    position: absolute;
    width: 100%;
    top: 50%;
    margin-top: -100px;
}
img{
    color: var(--theme-menu-item-selected-shadow-color);
}
</style>
